import React from 'react'
import styled from 'styled-components'
import { Badge } from '@120wateraudit/envirio-components'
import { serviceLineMaterialBadgeColor } from 'utils/serviceLineMaterialUtils'
import { Maybe } from 'generated/graphql'

export interface ServiceLineMaterialBadgeProps {
  material?: Maybe<string>
  color?: Maybe<string>
}

const ServiceLineMaterialBadge = ({
  material,
  color,
  ...rest
}: ServiceLineMaterialBadgeProps) => {
  const name = material
  const backgroundColor = serviceLineMaterialBadgeColor(color)

  return (
    <MaterialBadge backgroundColor={backgroundColor} {...rest}>
      {name}
    </MaterialBadge>
  )
}

const MaterialBadge = styled(Badge)`
  margin: 1px;
`

export default ServiceLineMaterialBadge
